import { useLoad } from "../lib/api.jsx";
import { Wait, Tbl } from "../lib/ui.jsx";

export default function Partners() {
  const [d] = useLoad("partners_overview");
  return (
    <>
      <h1>Partner overview</h1>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <div className="stats">
              <div className="stat"><b>{d.totals.partners}</b><span>Partners</span></div>
              <div className="stat"><b>{d.totals.members}</b><span>Members</span></div>
              <div className="stat"><b>{Number(d.totals.rewards).toLocaleString()}</b><span>Rewards recorded</span></div>
            </div>
            <h2>Partners by rewards</h2>
            <Tbl rows={d.rows.map((r, i) => ({ ...r, id: i }))} empty="No partner members yet. Add them under Partners in the sidebar." cols={[
              ["Partner", (r) => r.Name || r.partner], ["Members", (r) => r.members], ["Active members", (r) => r.active],
              ["Rewards", (r) => r.rewards], ["Total", (r) => Number(r.total).toLocaleString()],
            ]} />
          </>
        )}
      </Wait>
    </>
  );
}
